// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import router from './router';
import store from './store/index';

Vue.config.productionTip = false;

/* eslint-disable no-new */
new Vue({
  store,
  el: '#nivi-chat',
  router
});



// WEBPACK FOOTER //
// ./src/main.js